import React, { useState } from 'react';
import styled from 'styled-components';
import { ExtraMenu, Menu, MenuItem, Popconfirm } from 'components';

const DELETE_CONFIRMATION_MESSAGE =
  'Deleting this contact will remove their profile across the entire system including listing configurations.';

const POP_OVER_WIDTH = '25rem';
interface DropdownMenuProps {
  openChangeOwnerModal: () => void;
  deleteContact: () => void;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  openChangeOwnerModal,
  deleteContact,
}) => (
    <ExtraMenu
      overlayStyle={{ zIndex: 2001 }} // one higher than hardcoded mobile drawer zindex
      dropdownRender={() => (
        <Menu>
          <StyledMenuItem key={'delete'} disabled>
            <Popconfirm
              okText="Continue"
              onConfirm={deleteContact}
              placement="bottomLeft"
              overlayStyle={{
                width: POP_OVER_WIDTH,
                zIndex: 2002,
              }}
              title={DELETE_CONFIRMATION_MESSAGE}
            >
              <div className="fill" data-cy="contact-delete-option">
                Delete
              </div>
            </Popconfirm>
          </StyledMenuItem>

          <MenuItem
            key="change"
            onClick={openChangeOwnerModal}
            data-cy="contact-change-owner-option"
          >
            Change Owner
          </MenuItem>
        </Menu>
      )}
      trigger={['click']}
      placement="bottomRight"
    />
  );

const StyledMenuItem = styled(MenuItem)`
  display: flex;
  cursor: pointer !important;
  > div {
    display: flex;
    flex: 1 1 100%;
    div:last-child {
      flex: 1 1 100%;
      .fill {
        flex: 1 1 100%;
      }
    }
  }
`;

export default DropdownMenu;
